<template>
  <div class="alma">
    <!-- <div class="inner">
        <div class="container">
        </div>
    </div> -->
    <!-- Top Section indivual sim -->
    <div class="topBannerSection" v-for="(top, index) in topSection" :key="index" v-bind:style="{ 'background-image': 'url(' + top.image + ')' }">
        <b-container>
            <b-row>
                <b-col lg="6" sm="12">
                    <img class="logoImage" :src="top.logo_image">
                    <h2 class="headingOne" v-html="top.heading_one"></h2>
                    <h2 class="headingTwo" v-html="top.heading_two"></h2>
                    <div>
                        <b-link :to="top.button_left_link">
                            <button class="buttonTop" v-html="top.button_left_text"></button>
                        </b-link>
                        <b-link :to="top.button_right_link">
                            <button class="buttonTop" v-html="top.button_right_text"></button>
                        </b-link>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>

    <!-- Basket Section -->
    <b-container>
        <b-row v-for="(basket, index) in basketSection" :key="index" class="backetOption">
            <b-col lg="6" sm="12">
                <div class="bkImageBasket" v-bind:style="{ 'background-image': 'url(' + 'https://wp-ocssport.ocs-sport.com/imsim-uk/wp-content/uploads/sites/8/2025/02/Alma.png' + ')' }">
                </div>
            </b-col>
            <b-col lg="6" sm="12">
                <h2 class="maintitle red" v-html="basket.title"></h2>
                <p class="paraBasket" v-html="basket.paragraph"></p>
                <h2 class="red price" v-html="basket.price"></h2>
                <h3 class="simColour">Simulator Colour:</h3>
                <!-- <div class="contentBlock" v-html="content"></div> -->
                <b-form-group  v-slot="{ ariaDescribedby }">
                    <b-form-radio v-model="selected" :aria-describedby="ariaDescribedby" name="some-radios" value="A">Red</b-form-radio>
                    <b-form-radio v-model="selected" :aria-describedby="ariaDescribedby" name="some-radios" value="B">Blue</b-form-radio>
                    <b-form-radio v-model="selected" :aria-describedby="ariaDescribedby" name="some-radios" value="C">White</b-form-radio>
                    <b-form-radio v-model="selected" :aria-describedby="ariaDescribedby" name="some-radios" value="D">Yellow</b-form-radio>
                </b-form-group>
                <div id="outer">
                   <span class="quantityInput"> Quantity  <input type="number" id="quantity" name="quantity" min="1" max="100"></span>
                </div>
                <div data-v-5646ef74="" class="outButton">
                    <a data-v-5646ef74="" href="/" class="" rel="noopener" target="_blank">
                        <button data-v-5646ef74="" class="accessBasket"> Add to Basket </button>
                    </a>
                </div>
            </b-col>
        </b-row>
    </b-container>
    <b-container>
        <div class="hrLine">
            <hr>
        </div>
    </b-container>
    <!-- Imsim Simulator Description -->
    <div class="contactArea">
        <div class="container" v-for="(description, index) in SimulatorContent" :key="index">
            <div>
                <h2 class="maintitle red" v-html="description.title"></h2>
            </div>
            <b-row>
                <b-col>
                    <h2 class="descriptionParagraph" v-html="description.paragraph"></h2>
                    <p class="descriptionBulletPoints" v-html="description.bullet_points"></p>
                    <b-link :href="description.button_link" target="_blank">
                        <button class="descriptionButton">
                            <h2 class="descriptionButtonText" v-html="description.button_text"></h2>
                            <img class="youtubeSim" src="https://wp-ocssport.ocs-sport.com/imsim-uk/wp-content/uploads/sites/8/2025/02/YouTube_Icon.png">
                        </button>
                    </b-link>
                </b-col>
                <b-col>
                    <iframe width="100%" height="515" src="https://www.youtube.com/embed/K_5-IJ8rfgI?si=YhPzHxZ21sWJrQTT" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </b-col>
            </b-row>
        </div>
    </div>
    <!-- Banner Strip -->
    <div class="backgroundRed">
        <b-container>
            <b-row>
                <b-col lg="8" sm="12">
                    <h2 class="bannerText">Not sure which model is right for you?</h2>
                    <p class="bannerParagraph"> Visit our UK showroom to demo our cutting-edge simulators in action!
                        Our knowledgeable team is here to help you choose the ideal products to match
                        your needs and fit seamlessly into your available space.
                    </p>
                </b-col>
                <b-col lg="4" sm="12">
                    <b-link :to="'/showroom'" target="_blank">
                        <button class="accessDemo">
                            Arrange a Demo
                        </button>
                    </b-link>
                </b-col>
            </b-row>
        </b-container>
    </div>
    <!-- Middle block Section -->
    <div class="contactArea">
        <div class="" v-for="(content, index) in middleContent" :key="index" v-bind:style="{ 'background-color': content.back_ground_colour }">
            <b-row class="" style="margin:auto">
                <b-col lg="6" sm="12" v-bind:style="{ 'background-color': content.back_ground_colour }" :class="content.col_order_left_block">
                    <div :class="'midOuterContainer' + index">
                        <div class="container middleContainer" :class="content.paragraph_class">
                            <h2 class="Middletitle" v-bind:style="{ 'color': content.left_block_title_colour }" v-html="content.left_block_title"></h2>
                            <p class="Middleparagraph" v-bind:style="{ 'color': content.left_block_paragraph_colour }" v-html="content.left_block_content"></p>
                        </div>
                    </div>
                </b-col>
                <b-col lg="6" sm="12" class="imageblock" v-bind:style="{ 'background-image': 'url(' + content.right_block_content + ')' }" :class="content.col_order_right_block">

                </b-col>
            </b-row>
        </div>
    </div>

    <!-- Customize Section -->
    <div class="contactArea bkBlack">
        <div class="">
            <h2 class="title center red" v-html="customTitle"></h2>
            <p class="paragraph center white" v-html="customPara"></p>
            <b-row>
                <b-col class="custSimImage" lg="12" sm="12" v-for="(cust, index) in customSims" :key="index" v-bind:style="{ 'background-image': 'url(' + cust.sim_image + ')' }">
                </b-col>
            </b-row>
        </div>
    </div>

    <!-- Bottom Section -->
    <div class="contactArea bottomArea">
        <div class="container">
            <h2 class="BottomTitle">What makes ImSim Alma the perfect motion simulator?</h2>
            <b-row>
                <b-col lg="6" sm="12" v-for="(bottom, index) in bottomTerra" :key="index">
                    <h2 class="title" v-html="bottom.title"></h2>
                    <p class="paragraph" v-html="bottom.paragraph"></p>
                    <p class="bulletPoints" v-html="bottom.bullet_point_section"></p>
                </b-col>
            </b-row>
        </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Alma',
  components: {
  },
  data: function() {
    return {
      acf: [],
      content: [],
      bottomTerra: [],
      customTitle: '',
      customPara: '',
      customSims: [],
      middleContent: [],
      SimulatorContent: [],
      topSection: [],
      basketSection: [],
    };
  },
  methods: {
    isMobile() {
        if( screen.width <= 500 ) {
            return true;
        }
        else {
            return false;
        }
    },
  },
  mounted() {
    axios //add API Call
        .get(
            process.env.VUE_APP_API_URL + 'imsim-uk' + "/wp-json/wp/v2/pages/99" + '?randomadd=' +
          new Date().getTime()
        ) // Page number changed on each page based on JSON page id you are calling
        .then((response) => (
            this.acf = response.data,
            this.content = response.data.content.rendered,
            this.bottomTerra = response.data.acf.bottom_section,
            this.customSims = response.data.acf.custom_sim_images,
            this.customTitle = response.data.acf.customize_title,
            this.customPara = response.data.acf.customize_paragraph,
            this.middleContent = response.data.acf.middle_content_block_left_and_right,
            this.SimulatorContent = response.data.acf.simulator_description,
            this.basketSection = response.data.acf.basket_section,
            this.topSection = response.data.acf.top_banner_section
        )); //API data wanted pulled out
  },
}
</script>

<style scoped>
.quantityInput {
    color: #000;
}
div#outer {
    display: block;
    text-align: left;
    margin-top: 40px;
}
::v-deep ul {
    padding-left: 25px!important;
}
.midOuterContainer0 {
    max-width: 670px;
    display: flex;
    float: right;
    margin-top: 90px;
}
.midOuterContainer1 {
    max-width: 670px;
    display: flex;
    float: left;
    margin-top: 40px;
    margin-left: 80px
}
.midOuterContainer2 {
    max-width: 670px;
    display: flex;
    float: right;
    margin-top: 0px;
}
.midOuterContainer3 {
    max-width: 680px;
    display: flex;
    float: left;
    margin-top: 10px;
    margin-left: 80px
}
::v-deep h3.simColour {
    text-align: left;
    color: #000;
    font-size: 13pt;
    font-weight: bold;
    padding-top: 20px;
}
::v-deep label {
    color: #000;
    text-align: left;
    float: left;
}
::v-deep .custom-control {
    position: relative;
    z-index: 1;
    display: inline-flex;
    min-height: 1.5rem;
    padding-left: 1.5rem;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
    float: left;
    padding-right: 3em;
}
::v-deep a.reset_variations {
    display: none;
}
::v-deep .wc-block-components-product-price.wc-block-grid__product-price.has-text-align-.has-text-align- {
    display: grid;
}
::v-deep .quantity {
    padding-top: 15px;
}
::v-deep input#quantity_67e54044b4939 {
    width: 50px;
}
::v-deep span.woocommerce-Price-amount.amount {
    display: none;
}
::v-deep label.screen-reader-text {
    display: none;
}
::v-deep select#color {
    height: 33px;
    width: 171px;
    margin-left: -3px;
}
.contentBlock {
    text-align: left;
    color: #000;
    /* margin-top: 30px; */
}
::v-deep h4.wp-block-heading {
    font-size: 20px;
    font-weight: bold;
    padding-bottom: 20px;
}
::v-deep h3.wp-block-heading {
    font-size: 20px;
    font-weight: bold;
    padding-bottom: 20px;
}
::v-deep button.single_add_to_cart_button.button.alt {
    margin-top: 20px;
    width: 309px;
    height: 65px;
    background-color: #FD021D;
    color: #fff;
    font-weight: bold;
    border-color: #FD021D;
    font-size: 20px;
}
::v-deep button.single_add_to_cart_button.button.alt:hover {
    margin-top: 20px;
    width: 309px;
    height: 65px;
    background-color: #000;
    color: #fff;
    font-weight: bold;
    border-color: #000;
    font-size: 20px;
}
h2.price {
    text-align: left;
    font-weight: bolder;
    font-size: 30pt;
}
.backetOption {
    margin-top: 50px;
}
.bkImageBasket {
    height: 700px;
    background-position: bottom;
    background-size: cover;
    background-repeat: no-repeat;
}
.imageSrc {
    width: 100%;
}
.paraBasket {
    color: #000;
    text-align: left;
}
.hrLine {
    padding-top: 60px;
}
button.buttonTop {
    width: 309px;
    height: 65px;
    float: left;
    background-color: #fd021d;
    border: none;
    margin-right: 20px;
    color: #fff;
    font-weight: bold;
    font-size: 20px;
}
button.buttonTop:hover {
    background-color: #fff;
    color: #000;
}
.logoImage {
    width: 469px;
    height: 98px;
    float: left;
    margin-top: 50px;
    position: relative;
    left: -50px;
}
.headingOne {
    color: #FD021D;
    font-size: 60px;
    font-weight: 600;
    text-align: left;
    padding-top: 30px;
    display: inline-block;
}
.headingTwo {
    color: #fff;
    font-size: 50px;
    font-weight: 600; 
    text-align: left;
    padding-top: 30px;
    padding-bottom: 30px;
}
.topBannerSection {
    height: 908px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
.youtubeSim {
    width: 100px;
    position: absolute;
    right: 14em;
    bottom: 2em;
}
.descriptionButton {
    background-color: #FD021D;
    border: none;
    float: left;
    margin-bottom: 50px;
    width: 384px;
    height: 65px;
}
.descriptionButton:hover {
    background-color: #000;
    border: none;
    float: left;
    margin-bottom: 50px;
    width: 384px;
    height: 65px;
}
.descriptionButtonText {
    color: #fff;
    font-size: 20px;
    font-weight: bold;
    padding-bottom: 0;
    margin-bottom: 0;
}
.descriptionBulletPoints {
    color: #000;
    text-align: left;
    font-size: 18px;
}
h2.descriptionParagraph {
    color: #000;
    font-size: 18px;
    font-weight: bold;
    text-align: left;
    padding-bottom: 30px;
}
.maintitle {
    font-size: 40px;
    text-align: left;
    font-weight: bold;
    /* padding-top: 100px; */
    padding-top: 50px;
    padding-bottom: 30px;
}
button.accessBasket {
    width: 384px;
    height: 65px;
    background-color: #FD021D;
    border: none;
    color: #fff;
    font-weight: bold;
    margin-top: 45px;
    float: left;
}
button.accessBasket:hover {
    width: 384px;
    height: 65px;
    background-color: #000;
    border: none;
    color: #fff;
    font-weight: bold;
    margin-top: 45px;
    float: left;
}
button.accessDemo {
    width: 384px;
    height: 65px;
    background-color: #fff;
    border: none;
    color: #000;
    font-weight: bold;
    margin-top: 45px;
    float: right;
}
button.accessDemo:hover {
    width: 384px;
    height: 65px;
    background-color: #000;
    border: none;
    color: #fff;
    font-weight: bold;
    margin-top: 45px;
    float: right;
}
h2.bannerText {
    color: #fff;
    font-size: 27px;
    font-weight: bold;
    text-align: left;
}
p.bannerParagraph {
    color: #000;
    font-size: 25px;
    font-weight: bold;
    text-align: left
}
.backgroundRed {
    background: #FD021D;
    padding-top: 50px;
    padding-bottom: 50px;
}
.container.middleContainer.extrapad {
    /* margin-top: 100px; */
    /* margin-top: 140px; */
    margin-top: 70px;
}
.container.middleContainer {
    padding: 70px;
    padding-left: 0 !important;
}
h2.Middletitle {
    color: #FD021D;
    font-size: 40px;
    font-weight: bold;
    text-align: left;
    padding-bottom: 20px;
}
p.Middleparagraph {
    color: #000;
    font-size: 20px;
    text-align: left;
}
.imageblock {
    /* height: 600px; */
    /* height: 700px; */
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    min-height: 700px;
}
.custSimImage {
    height: 500px;
    background-position: bottom;
    background-repeat: no-repeat;
    background-size: cover;
}
.red {
    color: #FD021D!important;
}
.white {
    color: #fff!important;
}
.contactArea.bkBlack {
    background-color: #000;
    padding-top: 50px;
}
.center {
    text-align: center!important;
}
::v-deep ul {
    padding-left: 0;
}
::v-deep li {
    padding-left: 30px;
    padding-bottom: 20px;
}
::v-deep ::marker {
    color: #FD021D;
    font-size: 10px;
}
p.paragraph {
    font-weight: bold;
    font-size: 18px;
    color: #000000;
    text-align: left;
    padding-bottom: 20px;
}
p.bulletPoints {
    font-weight: 300;
    font-size: 16px;
    color: #000000;
    text-align: left;
}
.contactArea.bottomArea {
    padding-top: 50px;
    padding-bottom: 50px;
}
h2.title {
    font-weight: bold;
    color: #000000;
    text-align: left;
    padding-bottom: 20px;
    font-size: 32px;
}
h2.BottomTitle {
    color: #FD021D;
    font-weight: bolder;
    text-align: left;
    padding-bottom: 60px;
    font-size: 40px;
    padding-top: 30px;
}
.inner_accessories {
    background-image: url(https://wp-ocssport.ocs-sport.com/imsim-uk/wp-content/uploads/sites/8/2025/02/Accessories_Banner.png);
    background-repeat: no-repeat;
    height: 1000px;
    background-position: center;
    background-size: cover;
}
.contactArea {
    /* background-color: #FD021D; */
}
.contactTitle {
    color: #000000;
    font-size: 40px;
    font-weight: bold;
    text-align: left;
    margin-top: 200px;
    padding-bottom: 30px;
}
p.contactText {
    color: #fff;
    font-size: 25px;
    font-weight: bold;
    text-align: left;
    margin-bottom: 200px;
}
.mainHeader {
    color: #FD021D;
    font-size: 60px;
    font-weight: bold;
    text-align: left;
    margin-top: 150px;
}
.subHeader {
    color: #FFFFFF;
    font-size: 50px;
    font-weight: bold;
    text-align: left;
    margin-top: 30px;
}
.mainText {
    font-size: 18px;
    font-weight: bold;
    text-align: left;
    margin-top: 50px;
}
.linksBelow {
    margin-top: 50px;
}
button.accessBTN {
    width: 100%;
    height: 65px;
    background-color: #FD021D;
    border: none;
    color: #fff;
    font-weight: bold;
}
.youtube {
    width: 100px;
    position: absolute;
    top: -15px;
    right: -50px;
}


/* Media Query section */
@media only screen and (max-width: 1525px) {
    .container.middleContainer {
        padding: 70px!important;
        padding-left: 0px;
        padding-right: 0px;
    }
}
@media only screen and (max-width: 725px) {
    .custSimImage {
        height: 140px;
        background-position: bottom;
        background-repeat: no-repeat;
        background-size: cover;
    }
    .bkImageBasket {
        height: 480px;
        /* height: 700px; */
        background-position: bottom;
        background-size: cover;
        background-repeat: no-repeat;
    }
    .logoImage {
        margin-top: 0px;
        width: 100%;
    }
    .headingOne {
        font-size: 40px;
    }
    .headingTwo {
        font-size: 25px;
    }
    button.buttonTop {
        width: 100%;
        height: 65px;
        float: left;
        background-color: #fd021d;
        border: none;
        margin-right: 20px;
        color: #fff;
        font-weight: bold;
        font-size: 20px;
        margin-bottom: 20px;
    }
    .topBannerSection {
        height: 650px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }
    .youtubeSim {
        width: 100px;
        position: absolute;
        right: 0;
        bottom: 2em;
        display: none;
    }
    .descriptionBulletPoints {
        padding-left: 15px;
        padding-right: 15px;
    }
    iframe {
        width: 100%;
        height: 222px;
    }
    .contactArea {
        padding-bottom: 30px;
    }
    h2.bannerText {
        color: #fff;
        font-size: 25px;
        font-weight: bold;
        text-align: left;
        padding-bottom: 20px;
    }
    p.bannerParagraph {
        color: #000;
        font-size: 20px;
        font-weight: bold;
        text-align: left;
        padding-top: 20px;
    }
    .container.middleContainer {
        padding: 0px!important;
        padding-left: 0px;
        padding-right: 0px;
    }
    .midOuterContainer1 {
        max-width: 100%;
        display: flex;
        float: left;
        margin-top: 40px;
        margin-left: 0px;
        padding-bottom: 30px;
    }
    .container.middleContainer.extrapad {
        margin-top: 20px;
        padding-bottom: 30px;
    }
    .midOuterContainer2 {
        max-width: 670px;
        display: flex;
        float: right;
        margin-top: 30px;
        padding-bottom: 40px;
    }
    .midOuterContainer3 {
        max-width: 680px;
        display: flex;
        float: left;
        margin-top: 20px;
        margin-left: 0px;
        padding-bottom: 30px;
    }
    h2.title {
        padding-left: 10px;
        padding-right: 10px;
    }
    p.paragraph {
        font-weight: bold;
        font-size: 18px;
        color: #000000;
        text-align: left;
        padding-bottom: 20px;
        padding-left: 10px;
        padding-right: 10px;
    }
    h2.BottomTitle {
        color: #FD021D;
        font-weight: bolder;
        text-align: left;
        padding-bottom: 35px;
        font-size: 40px;
        padding-top: 10px;
    }
    button.accessDemo {
        width: 100%;
        height: 65px;
        background-color: #fff;
        border: none;
        color: #000;
        font-weight: bold;
        margin-top: 45px;
        float: right;
    }
    ::v-deep ul {
        padding-left: 20px;
    }
}

@media only screen and (max-width: 380px) {
    .descriptionButton {
        background-color: #FD021D;
        border: none;
        /* float: left; */
        margin-bottom: 50px;
        width: 340px;
        height: 65px;
    }
}
</style>
